<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-22 15:36:56
-->
<template>
	<div class="activityCell">
		<div v-if="isPallut">
			<div>货盘表：{{ row['pallet_name'] + '(ID：' + row['pallet_id'] + ')' }}</div>
		</div>
		<div v-if="isTeamGoods">
			<div class="time">
				推广时间：
				<span v-if="$isKs(row.platform_id)">
					{{ dayjs(row.promotion_start_time * 1000).format('YYYY-MM-DD') }} 至 {{ dayjs(row.promotion_end_time * 1000).format('YYYY-MM-DD') }}
				</span>
				<span v-else>
					<span v-if="row.promotion_time_text">
						{{ row.promotion_time_text }}
					</span>
					<span v-else>{{ row['promotion_start_date'] || '-' }} 至 {{ row['promotion_end_date'] || '-' }}</span>
				</span>
			</div>
			<div v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])">
				<span>活动名称：{{ row['activity_name'] ? row['activity_name'] : '-' }}</span>
				<el-tooltip placement="top" :open-delay="300">
					<span slot="content">
						<span>活动ID</span>
						<span class="ml-4">{{ row.outer_activity_id || '-' }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.outer_activity_id)"></i>
					</span>
					<span class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</span>
				</el-tooltip>
			</div>
			<div class="fz-14 flex flex-align-center">
				<div>团长：{{ row.institution_name || '-' }}</div>
				<el-tooltip placement="top" :open-delay="300">
					<div slot="content">
						<span>团长ID</span>
						<span class="ml-4">{{ row.authority_id || '-' }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.authority_id)"></i>
					</div>
					<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
				</el-tooltip>
			</div>
			<el-popover trigger="hover" placement="bottom" title="专属达人" width="180" :disabled="isDisabled">
				<div class="talent-info">
					<div v-for="(item, index) in row.activity_anchor" :key="index">
						<div class="fz-13 ml-4 yx-color-text-primary ellipsis">{{ item.outer_anchor_name }}</div>
						<span class="fz-12 yx-color-text-regular mt-6 info-id">
							{{ item.outer_anchor_id }}
						</span>
					</div>
				</div>
				<div :class="['tag', activityTypeTagType]" slot="reference" v-if="activityType">{{ activityType }}</div>
			</el-popover>
		</div>
		<div v-if="isTrusteeshipGoods" class="fz-14">
			<div>托管周期：</div>
			<div>{{ row.promotion_start_date || row.trusteeship_start_time || '-' }}至{{ row.promotion_end_date || row.trusteeship_end_time || '-' }}</div>
			<div class="fz-14 flex flex-align-center">
				<div>团长：{{ row.institutionName || row.institution_name || '-' }}</div>
				<el-tooltip placement="top" :open-delay="300">
					<div slot="content">
						<span>团长ID</span>
						<span class="ml-4">{{ row.authority_id || '-' }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.authority_id)"></i>
					</div>
					<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
				</el-tooltip>
			</div>
		</div>
		<div>
			<el-tooltip
				v-if="row.is_adjacent == 1"
				class="item"
				effect="dark"
				content="7天内活动将到期，请及时延长推广时间避免产生资损"
				placement="top-start"
			>
				<div class="tag mr-6">临近到期</div>
			</el-tooltip>
			<span v-if="row.approval_status == 'pending' && row.shopLibrary" class="tip_warning mr-6">延长推广审核中</span>
			<span v-if="row.approval_status == 'rejected' && row.shopLibrary" class="tip_danger mr-6">延长推广失效</span>
		</div>
		<div v-if="row.approval_status && row.shopLibrary" class="postpone" @click="handleShowPostpone">
			延长申请记录
			<i class="el-icon-d-arrow-right"></i>
		</div>

		<el-drawer destroy-on-close :size="600" append-to-body title="延长申请记录" :visible.sync="visiblePostpone">
			<div style="padding: 24px">
				<Tip style="margin-bottom: 14px" content="有效推广开始时间以合作方审核通过时间为准，最多展示50条申请记录。" />
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					element-loading-background="rgba(255, 255, 255)"
					:data="list"
					header-row-class-name="table-header-row"
					row-class-name="table-row"
				>
					<el-table-column prop="created_at" label="申请时间"></el-table-column>
					<el-table-column prop="extend_time" label="生效时间">
						<template v-slot="{ row }">
							<div v-if="row.approval_status == 'approved'">
								{{ row.extend_time }}
							</div>
							<div v-if="row.approval_status == 'pending'">申请审核中</div>
							<div v-if="row.approval_status == 'rejected'" class="flex-row-align-center ml-4">
								申请失败
								<el-tooltip v-if="row.fail_reason" class="item" effect="dark" placement="top" :content="row.fail_reason">
									<el-icon class="el-icon-question yx-color-info"></el-icon>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<empty ref="empty" slot="empty"></empty>
				</el-table>
			</div>
			<div style="height: 60px" />
			<div class="bottom-btn">
				<el-button type="primary" @click="visiblePostpone = false">关闭</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import mixin from './mixin';
import { PLATFORM_DY } from '@/utils/dataMap';
import dayjs from 'dayjs';
import empty from '@/views/common/empty/index.vue';
import { promoRecordsList } from '@/api/shopManage';
import { copy } from '@/utils/common';
export default {
	mixins: [mixin],
	data() {
		return {
			dayjs,
			visiblePostpone: false,
			loading: false,
			list: [
				{
					time1: '2023/3/1 15:10:11',
					time2: '2023/3/1 15:10:11',
				},
			],
		};
	},
	computed: {
		activityType() {
			const { showTag } = this.column;
			const { activity_type = '', platform_id = '' } = this.row;
			if (!showTag || platform_id == PLATFORM_DY.value) return '';
			const obj = {
				1: '普通活动',
				2: '专属活动',
				3: '合作招商',
			};
			return obj[activity_type];
		},
		activityTypeTagType() {
			const obj = {
				1: '',
				2: 'warningTag',
				3: 'successTag',
			};
			return obj[+this.row.activity_type];
		},
		isDisabled({ row }) {
			const { activity_anchor = [], activity_type } = row;
			return (this.$isDy(row.platform_id) || !activity_anchor.length) && activity_type == 1;
		},
		isPallut({ row }) {
			return +row.product_type === 1;
		},
		isTeamGoods({ row }) {
			return +row.product_type === 2 || +row.product_type === 3 || +row.product_type === 4;
		},
		isTrusteeshipGoods({ row }) {
			return +row.product_type === 5;
		},
	},
	methods: {
		async handleShowPostpone() {
			this.visiblePostpone = true;
			this.loading = true;
			try {
				const res = await promoRecordsList({
					product_id: this.row.product_id,
					platform: this.row.platform_id,
				});
				this.list = res;
			} finally {
				this.loading = false;
			}
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
	components: {
		empty,
	},
};
</script>
<style lang="less" scoped>
.tag {
	display: inline-block;
	height: 18px;
	line-height: 16px;
	padding: 0 4px;
	border-radius: 2px;
	font-size: 12px;
	color: @color-primary;
	background-color: @color-b1;
	border: 1px solid @color-b2;
}
.warningTag {
	color: @color-o;
	background-color: @color-o1;
	border: 1px solid @color-o2;
}
.successTag {
	color: @color-p4;
	background-color: @color-p1;
	border: 1px solid @color-p2;
}
.talent-info > :nth-child(n + 2) {
	margin-top: 16px;
}
.info-id {
	display: inline-block;
	border: 1px solid #eeeeee;
	padding: 0px 3px;
	border-radius: 2px;
}
.bottom-btn {
	border-top: 1px solid #eee;
	text-align: right;
	padding: 14px 24px;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	background: #fff;
	z-index: 1;
}
.tip_primary {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	background-color: #ebf2fd;
	color: @color-primary;
	font-size: 12px;
}
.tip_warning {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	background-color: #fff6f2;
	color: @color-warning;
	font-size: 12px;
}
.tip_danger {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	background-color: #fff3f2;
	color: @color-danger;
	font-size: 12px;
}
.postpone {
	color: #4e596a;
	font-size: 12px;
	cursor: pointer;
	&:hover {
		color: @color-primary;
	}
}
.tag-lable {
	padding: 0 3px;
	position: relative;
	top: -1px;
	height: 17px;
	border-radius: 3px;
	background-color: @color-gy4;
	margin-left: 4px;
}
</style>
